// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"2045":"ClientListSummary","2265":"Settings","4944":"SponsorsList","6837":"SettingsBasicPage","6905":"Demo","9801":"ClientList"}[chunkId] + "." + {"2045":"e9e4b860","2265":"e84b5a31","4944":"af45af30","6837":"47524da5","6905":"43ae200f","9801":"53850563"}[chunkId] + ".css";
};